import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  BeforeOpenCloseMenuEventArgs, DropDownButtonComponent,
  MenuEventArgs,
  OpenCloseMenuEventArgs
} from '@syncfusion/ej2-angular-splitbuttons';
import {TableOperationService} from "../../../core/services/table-operation/table-operation.service";
import {ContextMenu} from "../../../core/services/context-menu/context-menu";
import {ItemModel} from "@syncfusion/ej2-splitbuttons/src/common/common-model";
import {ContextMenuActionCallback} from "../../../core/services/context-menu/context-menu-types";
import {UtilService} from "../../../core/services/util/util.service";
import {ConfigMenuOverride} from "./config-menu-override";
import {InternationalizationService} from "../../../core/services/internationalization/internationalization.service";

@Component({
  selector: 'sb-content-page-header',
  templateUrl: './content-page-header.component.html',
  styleUrls: ['./content-page-header.component.scss']
})
export class ContentPageHeaderComponent implements OnInit, OnChanges {

  @Input()
  contentModel: any; // ListContentModel or DetailContentModel

  @Input()
  configMenuOverrides: ConfigMenuOverride;

  @Output()
  refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  menuItems: Promise<ItemModel[]> = Promise.resolve([]);

  // State in the template
  showTileHeader = false;
  recordLocked = false;
  recordHasNumberField = false;
  i18nTitle = "";

  constructor(private tableOperationService: TableOperationService,
              private utilService: UtilService,
              private i18nService: InternationalizationService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contentModel'] && changes['contentModel'].currentValue) {
      const viewModel = this.contentModel.viewModel;
      const data = this.contentModel.data;
      this.showTileHeader = viewModel.viewDefinition().properties.showTileHeader !== false;
      this.recordLocked = viewModel.getViewModelType() === 'detail' && data.hasOwnProperty('Active') && data.Active.value() === false;
      this.recordHasNumberField = viewModel.getViewModelType() === 'detail' && data.hasOwnProperty('Number') && data.Number.value();
      this.i18nTitle = this.i18nService.getMessage(this.contentModel.viewModel.getTitle());

      this.configureView().then((view) => {
        this.menuItems = Promise.resolve(view);
      });
    }
  }

  onRefresh(e: MouseEvent) {
    this.refresh.emit(true);
  }

  async configureView(): Promise<ItemModel[]> {
    const contextMenu: ContextMenu = this.tableOperationService.configureViewConfigMenu(this.contentModel);
    return contextMenu ? this.mapContextMenu(contextMenu) : Promise.resolve([]);
  }

  onBeforeOpen(_: BeforeOpenCloseMenuEventArgs) {
    this.menuItems = this.configureView();
  }

  // The drop down button does not support nested menus
  private async mapContextMenu(contextMenu: ContextMenu): Promise<ItemModel[]> {
    const contextMenuItems = await contextMenu.getMenuItems();
    const menuItems: ItemModel[] = contextMenuItems.map((c) => {
      if (c.isSeparator) {
        return {
          id: this.utilService.generateCSSID(),
          separator: true
        }
      }
      return {
          id: this.utilService.generateCSSID(),
          iconCss: c.prefixIcon ? c.prefixIcon : 'mi mi-fw',  // Putting anything here will cause the menu item to be indented correctly.
          text: c.label,
        _labelSuffix: c.labelSuffix,
        _actionCallback: c.actionCallback
        };
    });
    return menuItems;
  }

  onSelect(e: MenuEventArgs) {
    const actionCallback: ContextMenuActionCallback = (e.item as any)._actionCallback;
    if (actionCallback) {
      const result = actionCallback(e);

      if (result && this.configMenuOverrides && this.configMenuOverrides[result]) {
        this.configMenuOverrides[result](e);
      }
    }
  }

  onBeforeItemRender($event: MenuEventArgs) {
    // We need to rearrange the <span> to use the MI ligature form.
    const child = $event.element.firstElementChild;
    if (child && child.tagName == 'SPAN') {
      const iconCss = $event.item.iconCss;
      if (child.classList.contains("mi") || child.classList.contains("fi")) {
        // Leave it alone as it already contains CSS for displaying the icon
      } else {
        // The classList needs to have "mi" and the text needs to become iconCss
        child.classList.remove(iconCss);
        child.classList.add("mi");
        child.textContent = iconCss;
      }
    }
  }
}
